import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import LeadForm from '../components/LeadForm';
import ItemDialog from '../components/ItemDialog';

const PARTY_IMG = 'https://images.pexels.com/photos/19874598/pexels-photo-19874598.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

const ACTIVITIES = [
    {
        i: 'fa-music', t: 'Live DJ Nights',
        d: 'Top-tier DJs across the Caribbean circuit.',
        img: 'https://images.pexels.com/photos/19874598/pexels-photo-19874598.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
        blurb: 'Resident DJs from Miami, Ibiza, and the Caribbean circuit spinning sunset-to-sunrise. We unlock VIP DJ booth access, private dance floor sections, and bottle service tables. Themed nights every night.',
    },
    {
        i: 'fa-microphone-lines', t: 'Karaoke Marathons',
        d: 'Private rooms, themed competitions, prizes.',
        img: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=900&q=80',
        blurb: 'Reserve a private karaoke suite with full bar service. Bracket-style competitions, themed song lists (90s R&B night, Country gold, Latin fire), and engraved trophies for the winners. You will sing — and love it.',
    },
    {
        i: 'fa-mask-face', t: 'Theme Parties',
        d: 'White night, neon glow, masquerade, retro.',
        img: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=900&q=80',
        blurb: 'White Night, Neon Glow, Masquerade Ball, 70s Disco — every cruise gets at least two themed dress-up nights. We coordinate group attire, decorations, and a professional photographer for the memories.',
    },
    {
        i: 'fa-umbrella-beach', t: 'Beach Day Parties',
        d: 'Private cabanas, bottle service, sun-soaked.',
        img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=900&q=80',
        blurb: 'Private cabana takeovers at Half Moon Cay, CocoCay, and Sancho\'s Beach Club. Bottle service, dedicated server, jet ski rentals, and DJ on the sand. The full Miami-on-an-island day.',
    },
    {
        i: 'fa-cocktail', t: 'Cocktail Experiences',
        d: 'Mixology classes, tasting menus, top-shelf.',
        img: 'https://images.unsplash.com/photo-1514933651103-005eec06c04b?auto=format&fit=crop&w=900&q=80',
        blurb: 'Hands-on mixology classes with the head bartender, tasting menus pairing rum/tequila/mezcal flights with small plates, and a personalized signature cocktail named for your trip. Bring the recipe home.',
    },
    {
        i: 'fa-heart', t: 'Singles Meetups',
        d: 'Speed events, themed mixers, deck-side after-parties.',
        img: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?auto=format&fit=crop&w=900&q=80',
        blurb: 'Curated speed-dating sessions, themed mixers (Wine & Cheese, Salsa Night, Beach Game Day), and deck-side after-parties. Cabin grouping by age and interest so the connections start before boarding.',
    },
];

export default function PartyPage() {
    const [open, setOpen] = useState(null);
    return (
        <div>
            <section className="relative min-h-[60vh] overflow-hidden flex items-end">
                <img src={PARTY_IMG} alt="" className="absolute inset-0 h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-bg/20 to-brand-bg/90" />
                <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-10 pb-16 pt-32 w-full">
                    <div className="text-xs uppercase tracking-[0.3em] text-brand-pink mb-4">Party cruises</div>
                    <h1 className="font-display text-5xl sm:text-6xl lg:text-8xl font-black uppercase tracking-tighter">
                        We bring the <br /><span className="text-gradient-sunset">party</span> to the ocean
                    </h1>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-5 lg:px-10 py-16">
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {ACTIVITIES.map((a) => (
                        <button
                            key={a.t}
                            onClick={() => setOpen({ name: a.t, image: a.img, blurb: a.blurb, tag: 'Party Cruise', ctaLabel: 'Add to My Cruise' })}
                            data-testid={`party-tile-${a.t.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                            className="text-left bg-brand-surface border border-white/5 rounded-2xl p-7 hover:-translate-y-1 hover:border-brand-pink/50 transition-all"
                        >
                            <div className="h-12 w-12 rounded-xl bg-brand-pink/15 text-brand-pink flex items-center justify-center mb-5"><i className={`fa-solid ${a.i}`}></i></div>
                            <h3 className="font-display text-xl font-bold uppercase tracking-tight mb-2">{a.t}</h3>
                            <p className="text-sm text-white/65">{a.d}</p>
                        </button>
                    ))}
                </div>
                <div className="text-center mt-14">
                    <Button
                        onClick={() => document.querySelector('[data-testid="home-lead-form"]')?.scrollIntoView({ behavior: 'smooth' })}
                        className="btn-sunset rounded-full h-12 px-8 uppercase tracking-widest font-semibold"
                    >
                        Join the Next Adventure
                    </Button>
                </div>
            </section>
            <section className="max-w-7xl mx-auto px-5 lg:px-10 pb-20">
                <LeadForm />
            </section>
            <ItemDialog item={open} onClose={() => setOpen(null)} />
        </div>
    );
}
